import { render, staticRenderFns } from "./myPublish.vue?vue&type=template&id=009bcfb0&scoped=true"
import script from "./myPublish.vue?vue&type=script&lang=js"
export * from "./myPublish.vue?vue&type=script&lang=js"
import style0 from "./myPublish.vue?vue&type=style&index=0&id=009bcfb0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009bcfb0",
  null
  
)

export default component.exports